import { Fragment } from "react";

import { TableColumn, TableKey } from "../types";
import { ItemRow } from "./ItemRow";
import { ItemRowsSkeleton } from "./ItemRowsSkeleton";

const SKELETON_ROW_COUNT = 2;

interface ItemRowsProps<TDetail> {
    columns: TableColumn<TDetail>[];
    items: TDetail[];
    isLoading: boolean;
    getDetailKey: (item: TDetail) => TableKey;
}

/**
 * The expanded block under a `GroupRow`. Shows a skeleton when items are loading
 * and empty; otherwise renders an `ItemRow` per item.
 */
export function ItemRows<TDetail>({ columns, items, isLoading, getDetailKey }: ItemRowsProps<TDetail>) {
    if (isLoading && items.length === 0) {
        return <ItemRowsSkeleton columns={columns} rowCount={SKELETON_ROW_COUNT} />;
    }

    return (
        <Fragment>
            {items.map((item, i) => (
                <ItemRow<TDetail> key={getDetailKey(item)} columns={columns} data={item} index={i} />
            ))}
        </Fragment>
    );
}
